import React from "react";
import AdminDashboard from "../../Components/Admin/AdminDashboard";

const AdminHome = () => {
  return <AdminDashboard />;
};

export default AdminHome;
